import React from "react";
import { Navigate } from "react-router-dom";
import { isAdminLoggedIn } from "../../helpers/adminAuth";

const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (!isAdminLoggedIn()) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
